import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adforge_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adforge_token');
      if (window.location.pathname !== '/' && 
          window.location.pathname !== '/login' && 
          window.location.pathname !== '/signup') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ============== AUTH ==============
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (email, password, name) => api.post('/auth/register', { email, password, name }),
  googleSession: (sessionId) => api.post('/auth/google/session', { session_id: sessionId }),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout')
};

// ============== USAGE ==============
export const usageAPI = {
  getUsage: () => api.get('/usage')
};

// ============== GENERATION ==============
export const generatorAPI = {
  generateHooks: (productInput) => api.post('/generate/hooks', productInput),
  generateScripts: (productInput) => api.post('/generate/scripts', productInput),
  generateStoryboard: (productInput) => api.post('/generate/storyboard', productInput),
  generateVariations: (productInput) => api.post('/generate/variations', productInput),
  analyzeCompetitor: (competitorName, language = 'en') => api.post(`/generate/competitor-analysis?competitor_name=${encodeURIComponent(competitorName)}&language=${encodeURIComponent(language)}`),
  generateCreatorScript: (productInput) => api.post('/generate/creator-script', productInput),
  predictPerformance: (adContent, language = 'en') => api.post(`/generate/performance-prediction?ad_content=${encodeURIComponent(adContent)}&language=${encodeURIComponent(language)}`)
};

// ============== PROJECTS ==============
export const projectsAPI = {
  getAll: () => api.get('/projects'),
  getOne: (projectId) => api.get(`/projects/${projectId}`),
  create: (name, productInput) => api.post('/projects', { name, product_input: productInput }),
  update: (projectId, updates) => api.put(`/projects/${projectId}`, updates),
  delete: (projectId) => api.delete(`/projects/${projectId}`)
};

// ============== SUBSCRIPTIONS ==============
export const subscriptionsAPI = {
  getPlans: () => api.get('/subscriptions/plans'),
  createCheckout: (planId, originUrl, consent = {}) => api.post('/subscriptions/checkout', {
    plan_id: planId,
    origin_url: originUrl,
    withdrawal_waived: !!consent.withdrawal_waived,
    terms_accepted: !!consent.terms_accepted
  }),
  getStatus: (sessionId) => api.get(`/subscriptions/status/${sessionId}`)
};

export default api;
